// extracted by mini-css-extract-plugin
export default {"section":"R_MV_QvHLF","header":"BJegCzgure","line":"mqXwQUlQNC","title":"Hzz3k1AZ4c","titleAction":"mYCwmxBIe0"};